/**
 * StoreStatusPresenter
 * --
 */
import React from 'react';
import {
  Content,
  Row,
  Col,
  Descriptions,
  HtmlContent,
  ModalLayout,
  KakaoMap,
  UploadFile,
} from 'components';
import { Input, Button, DatePicker, Radio } from 'antd';
import moment from 'moment';
import dayjs from 'dayjs';
import Formatter from 'utils/Formatter';
import { openAddressModal } from 'utils/DaumAPIManager';

const StoreStatusPresenter = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const {
    data,
    isOpened,
    modalData,
    modalType,
    onChange,
    onOpen,
    onSubmit,
    files,
    onThumbnailFileChange,
    onStoreFileChange,
    onCoordChange,
  } = props;

  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
    tabTitle: {
      fontSize: 14,
      fontWeight: 600,
      color: '#404040',
    },
  };
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /**
   * 다음 주소 검색 Popup Open
   * --
   */
  const handleOpen = () => {
    openAddressModal((res) => {
      onChange('shop_information_postcode', res.zonecode, 'store');
      onChange('shop_information_address', res.address, 'store');
    });
  };

  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <Content maxWidth={'100%'} padding={10}>
        <Row>
          <Col x={8}>
            <Content maxWidth={'100%'} padding={10}>
              <h4
                style={{
                  ...styles.tabTitle,
                  height: 32,
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                위치정보
              </h4>
              <div style={{ marginTop: 3 }}>
                {data?.shop_information_address && (
                  <KakaoMap
                    address={data?.shop_information_address}
                    width={'100%'}
                  />
                )}
              </div>
              {/* <p
                style={{
                  textAlign: 'center',
                  marginTop: 10,
                  fontSize: 12,
                  fontWeight: 600,
                  color: '#898989',
                }}
              >
                클릭하여 큰 이미지 보기
              </p> */}
            </Content>
          </Col>
          <Col x={16}>
            <Content maxWidth={'100%'} padding={10}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  marginBottom: 5,
                  width: '100%',
                }}
              >
                <Button
                  type="primary"
                  style={{ background: 'var(--primary-color)', width: 73 }}
                  onClick={() =>
                    onOpen(isOpened, 'store', {
                      ...data,
                      business_num: data?.store_information?.business_num,
                      store_num: data?.store_information?.store_num,
                      business_hour: data?.store_information?.business_hour,
                      created_at: data?.created_at
                        ? Formatter.unixToDate(data?.created_at, 'YYYY-MM-DD')
                        : null,
                      GROUP: data?.store_information?.services?.GROUP, // 단체 이용가능여부
                      WIFI: data?.store_information?.services?.WIFI, // 무선 인터넷 사용 여부
                      PARKING: data?.store_information?.services?.PARKING, // 주차 가능 여부
                      RESTROOM: data?.store_information?.services?.RESTROOM, // 남녀 화장실 구분 여부
                      PACKAGING: data?.store_information?.services?.PACKAGING, // 포장 가능 여부
                      WHEELCHAIR: data?.store_information?.services?.WHEELCHAIR, // 출입구 휠체어 이용 가능 여부
                    })
                  }
                >
                  편집
                </Button>
              </div>
              <Descriptions
                align="left"
                items={[
                  {
                    key: `1`,
                    label: '매장명',
                    children: `${data?.shop_information_name}`,
                  },
                  {
                    key: `2`,
                    label: '사업자등록번호',
                    children: `${data?.store_information?.business_num}`,
                  },
                  {
                    key: `3`,
                    label: '등록일',
                    children: moment(data?.created_at).format(
                      'YYYY-MM-DD HH:mm:ss',
                    ),
                  },
                  {
                    key: `4`,
                    label: '대표자',
                    children: `${data?.admin?.admin_name || '-'}`,
                  },
                  {
                    key: `5`,
                    label: '주소',
                    children: `${data?.shop_information_address || '-'} ${
                      data?.shop_information_address_detail || ''
                    }`,
                    span: 2,
                  },
                  {
                    key: `6`,
                    label: '전화번호',
                    children: `${data?.store_information?.store_num}`,
                    span: 2,
                  },
                  {
                    key: `7`,
                    label: '메뉴 수',
                    children: `${data?.shop_menu?.length}개`,
                  },
                  {
                    key: `8`,
                    label: '직원 수',
                    children: `${data?.staff?.length}명`,
                  },
                  {
                    key: `10`,
                    label: '단체 이용',
                    children: (
                      <Radio.Group
                        options={[
                          { label: '가능', value: true },
                          { label: '불가능', value: false },
                        ]}
                        value={data?.store_information?.services?.GROUP}
                        optionType="button"
                        buttonStyle="solid"
                      />
                    ),
                  },
                  {
                    key: `11`,
                    label: 'WIFI 이용',
                    children: (
                      <Radio.Group
                        options={[
                          { label: '가능', value: true },
                          { label: '불가능', value: false },
                        ]}
                        value={data?.store_information?.services?.WIFI}
                        optionType="button"
                        buttonStyle="solid"
                      />
                    ),
                  },
                  {
                    key: `12`,
                    label: '주차 이용',
                    children: (
                      <Radio.Group
                        options={[
                          { label: '가능', value: true },
                          { label: '불가능', value: false },
                        ]}
                        value={data?.store_information?.services?.PARKING}
                        optionType="button"
                        buttonStyle="solid"
                      />
                    ),
                  },
                  {
                    key: `13`,
                    label: '포장 이용',
                    children: (
                      <Radio.Group
                        options={[
                          { label: '가능', value: true },
                          { label: '불가능', value: false },
                        ]}
                        value={data?.store_information?.services?.PACKAGING}
                        optionType="button"
                        buttonStyle="solid"
                      />
                    ),
                  },
                  {
                    key: `14`,
                    label: '휠체어 이용',
                    children: (
                      <Radio.Group
                        options={[
                          { label: '가능', value: true },
                          { label: '불가능', value: false },
                        ]}
                        value={data?.store_information?.services?.WHEELCHAIR}
                        optionType="button"
                        buttonStyle="solid"
                      />
                    ),
                  },
                  {
                    key: `15`,
                    label: '남녀 화장실 구분 여부',
                    children: (
                      <Radio.Group
                        options={[
                          { label: '구분', value: true },
                          { label: '비구분', value: false },
                        ]}
                        value={data?.store_information?.services?.RESTROOM}
                        optionType="button"
                        buttonStyle="solid"
                      />
                    ),
                  },
                  {
                    key: `16`,
                    label: '화장실 정보',
                    children: `${data?.toilet_information || '-'}`,
                    span: 2,
                  },
                  {
                    key: `17`,
                    label: 'WIFI 정보',
                    children: `${data?.wifi_information || '-'}`,
                    span: 2,
                  },
                  {
                    key: `9`,
                    label: '영업시간',
                    children: (
                      <>
                        <HtmlContent
                          content={`${data?.store_information?.business_hour}`}
                          style={{ textAlign: 'left', padding: '20px 0' }}
                        />
                      </>
                    ),
                  },
                ]}
              />
            </Content>
          </Col>
        </Row>
      </Content>

      <ModalLayout
        type="modal"
        centered
        title={'지점 정보'}
        open={isOpened && modalType === 'store'}
        onCancel={() => onOpen(isOpened)}
        closable
        width={'50%'}
        footer={
          <Content
            maxWidth={'100%'}
            padding={0}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 10,
            }}
          >
            <Button onClick={() => onOpen(isOpened)}>닫기</Button>
            <Button type="primary" onClick={() => onSubmit('store', 'UPDATE')}>
              저장
            </Button>
          </Content>
        }
      >
        <Content maxWidth={'100%'} padding={'30px 0px'}>
          <Row>
            <Col x={24}>
              <Content maxWidth={'100%'} padding={0}>
                <Descriptions
                  items={[
                    {
                      key: 'shop_information_name',
                      label: (
                        <p>
                          매장명<span style={{ color: '#F94F1A' }}>*</span>
                        </p>
                      ),
                      children: (
                        <Input
                          size="large"
                          value={modalData?.store?.shop_information_name || ''}
                          placeholder="매장명을 입력해주세요"
                          onChange={(e) =>
                            onChange(
                              'shop_information_name',
                              e.target.value,
                              'store',
                            )
                          }
                        />
                      ),
                    },
                    {
                      key: 'business_num',
                      label: '사업자등록번호',
                      children: (
                        <Input
                          size="large"
                          value={modalData?.store?.business_num || ''}
                          placeholder="사업자등록번호를 입력해주세요"
                          onChange={(e) =>
                            onChange(
                              'business_num',
                              Formatter.hyphen(e.target.value, 'business_num'),
                              'store',
                            )
                          }
                        />
                      ),
                    },
                    {
                      key: 'created_at',
                      label: '등록일',
                      children: (
                        <DatePicker
                          size="large"
                          value={
                            modalData?.store?.created_at &&
                            dayjs(modalData?.store?.created_at)
                          }
                          style={{ width: '100%' }}
                          disabled
                        />
                      ),
                    },
                    {
                      key: 'owner_name',
                      label: '대표자',
                      children: (
                        <Input
                          size="large"
                          value={modalData?.store?.admin?.admin_name || ''}
                          placeholder="대표자명을 입력해주세요"
                          disabled
                        />
                      ),
                    },
                    {
                      key: 'address',
                      label: '주소',
                      span: 2,
                      children: (
                        <Input
                          size="large"
                          value={
                            modalData?.store?.shop_information_address || ''
                          }
                          placeholder="주소를 입력해주세요"
                          onChange={(e) =>
                            onChange(
                              'shop_information_address',
                              e.target.value,
                              'store',
                            )
                          }
                        />
                      ),
                    },
                    {
                      key: 'address',
                      label: '주소',
                      span: 2,
                      children: (
                        <>
                          <div
                            style={{
                              width: '100%',
                              display: 'flex',
                              padding: '10px 0',
                              flexDirection: 'column', // 세로 정렬
                              alignItems: 'flex-start', // 왼쪽 정렬
                              gap: '10px', // 요소 간 간격
                            }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                              }}
                            >
                              <Input
                                size="large"
                                value={
                                  modalData?.store?.shop_information_postcode ||
                                  ''
                                }
                                placeholder="우편번호"
                                readOnly
                                style={{ width: 300 }}
                              />
                              <Button size="large" onClick={() => handleOpen()}>
                                주소찾기
                              </Button>
                            </div>
                            <Input
                              size="large"
                              value={
                                modalData?.store?.shop_information_address || ''
                              }
                              placeholder="주소"
                              readOnly
                              style={{ width: 500 }}
                            />
                            <Input
                              size="large"
                              value={
                                modalData?.store
                                  ?.shop_information_address_detail || ''
                              }
                              onChange={(e) =>
                                onChange(
                                  'shop_information_address_detail',
                                  e.target.value,
                                  'store',
                                )
                              }
                              placeholder="상세주소"
                              style={{ width: 500 }}
                            />
                            <KakaoMap
                              width={500}
                              address={
                                modalData?.store?.shop_information_address || ''
                              }
                              name={
                                modalData?.store?.shop_information_name || ''
                              }
                              onChange={(lat, lng) => onCoordChange(lat, lng)}
                            />
                          </div>
                        </>
                      ),
                    },
                    {
                      key: 'store_num',
                      label: '전화번호',
                      span: 2,
                      children: (
                        <Input
                          size="large"
                          value={modalData?.store?.store_num || ''}
                          placeholder="전화번호를 입력해주세요"
                          onChange={(e) =>
                            onChange('store_num', e.target.value, 'store')
                          }
                        />
                      ),
                    },
                    {
                      key: 'menu_count',
                      label: '메뉴 수',
                      children: `${modalData?.store?.shop_menu?.length || 0}개`,
                    },
                    {
                      key: 'staff_count',
                      label: '직원 수',
                      children: `${modalData?.store?.staff?.length || 0}명`,
                    },

                    {
                      key: 'toilet_information',
                      label: '화장실 정보',
                      span: 2,
                      children: (
                        <Input
                          size="large"
                          value={modalData?.store?.toilet_information || ''}
                          placeholder="화장실 정보를 입력해주세요"
                          onChange={(e) =>
                            onChange(
                              'toilet_information',
                              e.target.value,
                              'store',
                            )
                          }
                        />
                      ),
                    },
                    {
                      key: 'wifi_information',
                      label: 'WIFI 정보',
                      span: 2,
                      children: (
                        <Input
                          size="large"
                          value={modalData?.store?.wifi_information || ''}
                          placeholder="WIFI 정보를 입력해주세요"
                          onChange={(e) =>
                            onChange(
                              'wifi_information',
                              e.target.value,
                              'store',
                            )
                          }
                        />
                      ),
                    },
                    {
                      key: 'business_hour',
                      label: '영업시간',
                      span: 2,
                      children: (
                        <Input.TextArea
                          value={modalData?.store?.business_hour || ''}
                          placeholder="영업시간을 입력해주세요"
                          style={{ minHeight: 78 }}
                          onChange={(e) =>
                            onChange('business_hour', e.target.value, 'store')
                          }
                        />
                      ),
                    },
                    {
                      key: 'thumbnail',
                      label: '매장 썸네일',
                      style: { padding: '10px 20px' },
                      children: (
                        <UploadFile
                          files={files.thumbnail}
                          preview
                          multiple
                          max={1}
                          onChange={onThumbnailFileChange}
                        />
                      ),
                      span: 2,
                    },
                    {
                      key: 'store',
                      label: '매장 사진',
                      style: { padding: '10px 20px' },
                      children: (
                        <UploadFile
                          files={files.store}
                          preview
                          multiple
                          max={5}
                          onChange={onStoreFileChange}
                        />
                      ),
                      span: 2,
                    },
                    {
                      key: 'GROUP',
                      label: '단체 이용',
                      children: (
                        <>
                          <Radio.Group
                            options={[
                              { label: '가능', value: true },
                              { label: '불가능', value: false },
                            ]}
                            onChange={(e) =>
                              onChange('GROUP', e.target.value, 'store')
                            }
                            value={modalData?.store?.GROUP}
                            optionType="button"
                            buttonStyle="solid"
                          />
                        </>
                      ),
                    },
                    {
                      key: 'WIFI',
                      label: 'WIFI 이용',
                      children: (
                        <>
                          <Radio.Group
                            options={[
                              { label: '가능', value: true },
                              { label: '불가능', value: false },
                            ]}
                            onChange={(e) =>
                              onChange('WIFI', e.target.value, 'store')
                            }
                            value={modalData?.store?.WIFI}
                            optionType="button"
                            buttonStyle="solid"
                          />
                        </>
                      ),
                    },
                    {
                      key: 'PARKING',
                      label: '주차 이용',
                      children: (
                        <>
                          <Radio.Group
                            options={[
                              { label: '가능', value: true },
                              { label: '불가능', value: false },
                            ]}
                            onChange={(e) =>
                              onChange('PARKING', e.target.value, 'store')
                            }
                            value={modalData?.store?.PARKING}
                            optionType="button"
                            buttonStyle="solid"
                          />
                        </>
                      ),
                    },
                    {
                      key: 'PACKAGING',
                      label: '포장 이용',
                      children: (
                        <>
                          <Radio.Group
                            options={[
                              { label: '가능', value: true },
                              { label: '불가능', value: false },
                            ]}
                            onChange={(e) =>
                              onChange('PACKAGING', e.target.value, 'store')
                            }
                            value={modalData?.store?.PACKAGING}
                            optionType="button"
                            buttonStyle="solid"
                          />
                        </>
                      ),
                    },
                    {
                      key: 'WHEELCHAIR',
                      label: '휠체어 이용',
                      children: (
                        <>
                          <Radio.Group
                            options={[
                              { label: '가능', value: true },
                              { label: '불가능', value: false },
                            ]}
                            onChange={(e) =>
                              onChange('WHEELCHAIR', e.target.value, 'store')
                            }
                            value={modalData?.store?.WHEELCHAIR}
                            optionType="button"
                            buttonStyle="solid"
                          />
                        </>
                      ),
                    },
                    {
                      key: 'RESTROOM',
                      label: '남녀 화장실 구분 여부',
                      children: (
                        <>
                          <Radio.Group
                            options={[
                              { label: '구분', value: true },
                              { label: '비구분', value: false },
                            ]}
                            onChange={(e) =>
                              onChange('RESTROOM', e.target.value, 'store')
                            }
                            value={modalData?.store?.RESTROOM}
                            optionType="button"
                            buttonStyle="solid"
                          />
                        </>
                      ),
                    },
                  ]}
                />
              </Content>
            </Col>
          </Row>
        </Content>
      </ModalLayout>
    </>
  );
};

export default StoreStatusPresenter;
